import { Navbar } from "@/components/site/Navbar";
import { AlbumExperience } from "@/components/site/AlbumExperience";
import { ListSignup } from "@/components/site/ListSignup";
import { useIsMobile } from "@/hooks/useIsMobile";
import { LEADMAGNET_DESCRIPTION } from "@/data/site";

// Low-friction conversion portal (e.g. a link-in-bio destination). Nothing
// on this page ever repositions left or right — see AlbumExperience for
// the full sequence (CD animation -> crossfade to Stream Everywhere / Get
// the Song Directly, all centered in place). This same component is reused
// at a smaller scale inside a promo card on the Music page.
export default function NewAlbum() {
  const isMobile = useIsMobile();
  // Mobile: the full-size (scale=1) opened spread is ~640px wide, wider
  // than any phone viewport — reduced enough that the opened sequence's
  // full horizontal extent fits with no overflow/horizontal scroll.
  const scale = isMobile ? 0.5 : 1;

  return (
    <div className="starfield relative bg-[var(--sm-black)]">
      <div
        className="fixed inset-0 z-0 overflow-hidden"
        style={{ background: "radial-gradient(ellipse at 50% 0%, var(--sm-brown-deep) 0%, transparent 65%)" }}
      >
        <div aria-hidden className="nebula opacity-60" />
      </div>
      <Navbar />
      {/* CD-opening experience, then the signup form right underneath it —
          close enough to read as part of the same moment (not a whole
          separate screen away, which buried it entirely off-screen before),
          but still with a real gap so it doesn't crowd the animation.
          CDAnimation's own box only ever grows in width, never in height,
          so this gap clears it at every phase regardless of scale/width. */}
      <main className="relative z-10 flex flex-col items-center px-6 pb-24 pt-24 lg:min-h-screen lg:justify-center">
        <div className="flex flex-col items-center justify-center">
          <AlbumExperience scale={scale} mobile={isMobile} />
        </div>

        <div className="mt-10 flex w-full flex-col items-center text-center sm:mt-14">
          <span className="overline">Stay Close</span>
          <h2 className="font-display mt-3 text-2xl text-[var(--sm-text)] sm:text-3xl">Hear It First</h2>
          <p className="font-body mt-3 max-w-sm text-sm font-light text-white/60">{LEADMAGNET_DESCRIPTION}</p>
          <div className="mt-8 w-full max-w-md">
            <ListSignup />
          </div>
        </div>
      </main>
    </div>
  );
}
